import {Feature, Features} from "../feature";
import {MolecularGraph} from "../graph/MolecularGraph"
import {atomCollector} from "../util/atomCollector";
import {extractorUtil} from "../util/extractorUtil";

export const looseAtomsFilter = {
    filterInPlace: (features: Feature[], graph: MolecularGraph) => {
        const unusedAtoms = atomCollector.collectUnusedAtoms(features, graph);

        // We only care about heavy atoms.
        const heavy = extractorUtil.getHeavyAtoms(unusedAtoms);

        // PIPH-122: Track which hydrogens have already been assigned to a feature
        const assignedHydrogens = new Set<typeof unusedAtoms[number]>();

        const newFeatures = heavy.reduce((acc, atom) => {
            // PIPH-122: Include bonded hydrogens from unusedAtoms in the feature.
            // This ensures atoms like H₂O have all their atoms in the feature,
            // so getAtomNameWithContext() can find them.
            const bondedHydrogens = graph.getBondsAttachedTo(atom)
                .map(b => b.getOtherAtom(atom))
                .filter(other =>
                    other.symbol === "H" &&
                    unusedAtoms.includes(other) &&
                    !assignedHydrogens.has(other)
                );

            // Mark these hydrogens as assigned
            for (const h of bondedHydrogens) {
                assignedHydrogens.add(h);
            }

            acc.push({
                name: `${Features.atom}.${atom.symbol}`,
                atoms: [atom, ...bondedHydrogens],
                connections: extractorUtil.getNonHConnectedAtoms(atom, graph)
            } as Feature)
            return acc;
        }, [] as Feature[])

        features.push(...newFeatures);

        return newFeatures;
    }
}
